import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { RegistrationService } from '../services/registration.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  resetPasswordForm: FormGroup;
  token: string | null = null;
  submitText = 'Submit';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] || null;
    });
    this.forgotPasswordForm = this.fb.group({
      username: ['', Validators.required],
    });
    this.resetPasswordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
      },
      { validators: this.passwordsMatchValidator },
    );
  }

  passwordsMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

  get r() {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid) return;
    this.submitText = 'Please Wait ...';
    const { username } = this.forgotPasswordForm.value;
    this.registrationService.forgotPassword(username).subscribe(
      (response) => {
        Swal.fire({
          icon: 'success',
          text: response?.message || 'If the username exists, a password reset link has been sent to its email address.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['/login']);
        });
      },
      (error) => {
        console.error(error);
        this.submitText = 'Submit';
        Swal.fire({
          icon: 'error',
          text: error.error?.message || 'Request failed. Please try again.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    );
  }

  onResetSubmit() {
    if (this.resetPasswordForm.invalid || !this.token) return;
    this.submitText = 'Please Wait ...';
    const { password } = this.resetPasswordForm.value;
    this.registrationService.resetPassword(this.token, password).subscribe(
      () => {
        Swal.fire({
          icon: 'success',
          text: 'Password updated. You can now log in.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['/login']);
        });
      },
      (error) => {
        console.error(error);
        this.submitText = 'Submit';
        Swal.fire({
          icon: 'error',
          text: error.error?.message || 'The reset link is invalid or has expired.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    );
  }
}
